import axios from 'axios'
import applyCaseMiddleware from 'axios-case-converter'
import { API_PATH, SYSTEM_ERROR } from '@/common/constants'
import csrf from '@/common/utils/csrf'
import { handleExpireSessionError } from '@/common/utils/common'

const {
  headerKey,
  csrfToken
} = csrf()
const showError = handleExpireSessionError()
const getAxiosInstance = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
    headers: {
      [headerKey]: csrfToken
    }
  })
  instance.interceptors.response.use(function(response) {
    return response
  }, function(error) {
    if (error.response.status === 422) {
      error.message = SYSTEM_ERROR.UNKNOWN
      showError()
      return Promise.reject(error)
    }
    return Promise.reject(error)
  })
  return instance
}
const httpClient = (baseURL: string = API_PATH) => applyCaseMiddleware(getAxiosInstance(baseURL))

export const httpClientRoot = httpClient('/')
export default httpClient()
